import {createAction, createReducer} from '@reduxjs/toolkit'
const SET_MESSAGE_DATA = 'SET_MESSAGE_DATA'
const SET_CURRENT_USER = 'SET_CURRENT_USER'

export const setMessageData = createAction<any>(SET_MESSAGE_DATA)
export const setUserProfileData = createAction<any>(SET_CURRENT_USER)
export const setProjectData = createAction<any>('SET_PROJECT_DATA')
export const setProjectTab1 = createAction<any>('SET_PROJECT_TAB_1')
export const setProjectTab2 = createAction<any>('SET_PROJECT_TAB_2')
export const setProjectTab3 = createAction<any>('SET_PROJECT_TAB_3')
export const setProjectTab4 = createAction<any>('SET_PROJECT_TAB_4')
export const setProjectTab5 = createAction<any>('SET_PROJECT_TAB_5')
export const setProjectActiveTabAll = createAction<any>('SET_PROJECT_ACTIVE_TAB_ALL')
export const setProjectDesableTabAll = createAction<any>('SET_PROJECT_DESABLE_TAB_ALL')
export const setProjectResetData = createAction<any>('SET_PROJECT_RESET_DATA')
export const setProjectEditing = createAction<any>('SET_PROJECT_EDITING')
export const setIsThereNonSavedForm = createAction<boolean>('SET_PROJECT_NOT_SAVED_DATA')
export const setIsNotSelectedMaterial = createAction<boolean>('SET_TERM_NOT_SELECTED')
export const setTermUseListUsageMaterial = createAction('SET_TERM_USE_LIST_USAGE_MATERIAL')
export const setProjectStatus = createAction<any>('SET_PROJECT_STATUS')

export const toggleTokenRefreshed = createAction('token/toggleRefresh')
export const setValidToken = createAction<boolean>('token/setValid')
export const setStatusResponseServer = createAction<any>('SET_STATUS_SERVER')

interface ITokenState {
  refreshed: boolean
  valid: boolean
}

export type ProjectStatus = {
  Submitted: boolean | null
}
export type MaterialList = {
  Guid: string
  Name?: string | null
  Code?: string | null
  PhotoName?: string | null
  FileName?: string | null
  Description?: string | null
  Width?: number | null
  Height?: number | null
  Length?: number | null
  Weight?: number | null
  Selected?: boolean
}
export type AppState = {
  messagePopup: MessagePopup | null
  actualPerson: any
  userProfileData: any
  project: any
  projectEditing: any
  isThereNonSavedForm: boolean
  isNotSelectedMaterial: boolean
  termeUse: {
    listUsageMaterial: MaterialList[]
  } //| any
  projectStatus: ProjectStatus
  accessTokenState: ITokenState | any
}

export type MessagePopup = {
  Message: string
  MessageType: string
}
const initialModalState: AppState = {
  messagePopup: {
    Message: '',
    MessageType: '',
  },
  actualPerson: null,
  userProfileData: null,
  projectEditing: null,
  isThereNonSavedForm: false,
  isNotSelectedMaterial: false,
  project: {
    tab1: {
      disabled: false,
      data: null,
      active: true,
    },
    tab2: {
      disabled: true,
      data: null,
      active: false,
    },
    tab3: {
      disabled: true,
      data: null,
      active: false,
    },
    tab4: {
      disabled: true,
      data: null,
      active: false,
    },
    tab5: {
      disabled: true,
      data: null,
      active: false,
    },
  },
  termeUse: {
    listUsageMaterial: [],
  },
  projectStatus: {
    Submitted: null,
  },
  accessTokenState: {
    refreshed: false,
    valid: false,
  },
}

export const modalReducer = createReducer(initialModalState.messagePopup, (builder) => {
  builder.addCase(setMessageData, (state, action) => {
    return action.payload
  })
})

export const userProfileReducer = createReducer(initialModalState.userProfileData, (builder) => {
  builder.addCase(setUserProfileData, (state, action) => {
    return action.payload
  })
})

export const projectEditingReducer = createReducer(initialModalState.projectEditing, (builder) => {
  builder.addCase(setProjectEditing, (state, action) => {
    return action.payload
  })
})

export const isThereNonSavedFormReducer = createReducer(
  initialModalState.isThereNonSavedForm,
  (builder) => {
    builder.addCase(setIsThereNonSavedForm, (state, action) => {
      return action.payload
    })
  }
)

export const isNotSelectedMaterialReducer = createReducer(
  initialModalState.isNotSelectedMaterial,
  (builder) => {
    builder.addCase(setIsNotSelectedMaterial, (state, action) => {
      return action.payload
    })
  }
)

export const termUseReducer = createReducer(initialModalState.termeUse, (builder) => {
  return builder.addCase(
    setTermUseListUsageMaterial,
    (draft, action: {payload: any[] | any | MaterialList[]; type: string}) => {
      draft.listUsageMaterial = action.payload as any[] | MaterialList[]
      return
    }
  )
})

export const projectReducer = createReducer(initialModalState.project, (builder) => {
  return builder
    .addCase(setProjectTab1, (draft, action) => {
      draft.tab1 = action.payload
      return
    })
    .addCase(setProjectTab2, (draft, action) => {
      draft.tab2 = action.payload
      return
    })
    .addCase(setProjectTab3, (draft, action) => {
      draft.tab3 = action.payload
      return
    })
    .addCase(setProjectTab4, (draft, action) => {
      draft.tab4 = action.payload
      draft.tab5 = {
        disabled: true,
        data: null,
        active: false,
      }
      return
    })
    .addCase(setProjectTab5, (draft, action) => {
      draft.tab5 = action.payload
      return
    })
    .addCase(setProjectActiveTabAll, (draft) => {
      draft.tab1.disabled = false
      draft.tab2.disabled = false
      draft.tab3.disabled = false
      draft.tab4.disabled = false
      draft.tab5.disabled = false
      return
    })
    .addCase(setProjectDesableTabAll, (draft) => {
      draft.tab1.disabled = false
      draft.tab2.disabled = true
      draft.tab3.disabled = true
      draft.tab4.disabled = true
      draft.tab5.disabled = true
      return
    })
    .addCase(setProjectResetData, (draft) => {
      return initialModalState.project
    })
    .addCase(setProjectData, (draft, action) => {
      return action.payload
    })
})

export const projectStatusReducer = createReducer(initialModalState.projectStatus, (builder) => {
  builder.addCase(setProjectStatus, (state, action) => {
    return action.payload
  })
})

export const statusServerResponseReducer = createReducer(
  initialModalState.actualPerson,
  (builder) => {
    return builder.addCase(setStatusResponseServer, (draft, action) => {
      return action?.payload
    })
  }
)

export const accessTokenReducer = createReducer(initialModalState.accessTokenState, (builder) => {
  return builder
    .addCase(toggleTokenRefreshed, (draft) => {
      draft.refreshed = !draft.refreshed
      return
    })
    .addCase(setValidToken, (draft, action) => {
      draft.valid = action.payload
      return
    })
})
